module.exports = __webpack_public_path__ + "static/banner-maritimo-2f6fe125ac93f4bd54d64c91a3b3303c.jpg";